import { Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import { delay } from 'Utility/Task/TaskQueue';

export interface ICardStackBuildUpMeta {
    x: number;
    y: number;
    duration: number;
}

export class CardStackBuildUp extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta: ICardStackBuildUpMeta
    ): IterableIterator<number> {
        meta.duration = meta.duration || 300;

        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        const tweenPosition = this.getTween(transform.position);
        const tweenRotation = this.getTween(transform);
        const tweenSkew = this.getTween(transform.skew);

        tweenSkew
            .to(
                {
                    x: 0,
                    y: 0,
                },
                meta.duration
            )
            .easing(Easing.Quadratic.Out)
            .start(this.elapsedTime);

        tweenPosition
            .to(
                {
                    x: meta.x,
                    y: meta.y,
                },
                meta.duration
            )
            .easing(Easing.Quadratic.Out)
            .start(this.elapsedTime);

        yield* delay(200);

        tweenRotation
            .to(
                {
                    rotation: 0,
                },
                300
            )
            .easing(Easing.Quadratic.Out)
            .start(this.elapsedTime);

        yield* this.startTween(tweenRotation);
    }
}
